import { securityOidcConfigurationsByCustomerIdByIdGetSlice } from './get';

export const {
	requestGetSecurityOidcConfigurationsByCustomerById,
	resetGetSecurityOidcConfigurationsByCustomerById
} = securityOidcConfigurationsByCustomerIdByIdGetSlice.asyncActionCreators;
